import { API_ROUTES } from '../constants';
import apiClient from './apiClient';

const instanceService = {
    getAllByCompany: async (companyId) => {
        try {
            const response = await apiClient.get(
                `${API_ROUTES.INSTANCES}/${companyId}`
            );
            if (response.status !== 200) {
                throw new Error(`Request failed with status ${response.status}`);
            }
            const data = response?.data?.data;
            return Array.isArray(data) ? data : [];
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch instances');
        }
    }
};

export default instanceService;
